export const SET_HAS_JOB_INFORMATION = 'SET_HAS_JOB_INFORMATION';

export const SetHasJobInformation = (value) => {
    return {
        type: SET_HAS_JOB_INFORMATION,
        payload: {
            value: value
        }
    }
}